module.exports = require("react-swipeable-views");